


































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import SuporteHospitaisStore, { DeFinxParaHis } from '@/components/Suporte/Store/SuporteHospitaisStore'

@Component
export default class ComponentModalSuporteDeFinxParaHis extends Vue {
  loadDeleteDeFinxParaHis: boolean = false
  loadUpsertDeFinxParaHis: boolean = false
  createEditRegra: boolean = false
  confirmExclusao: boolean = false
  deFinxParaHisTableHeader: any[] = [
    { text: 'Propriedade Fin-X', align: 'left', value: 'propriedadeFinx', sortable: false },
    { text: 'Valor Fin-X', align: 'left', value: 'valorFinx', sortable: false },
    { text: '', align: 'center', value: '', sortable: false },
    { text: 'Propriedade His', align: 'left', value: 'propriedadeHis', sortable: false },
    { text: 'Valor His', align: 'left', value: 'valorHis', sortable: false },
    { text: 'Ações', align: 'center', value: '', sortable: false },
  ]

  get loadingDeleteDeFinxParaHis() { return this.loadDeleteDeFinxParaHis }
  set loadingDeleteDeFinxParaHis(value: boolean) { this.loadDeleteDeFinxParaHis = value }
  get loadingUpsertDeFinxParaHis() { return this.loadUpsertDeFinxParaHis }
  set loadingUpsertDeFinxParaHis(value: boolean) { this.loadUpsertDeFinxParaHis = value }
  get criarEditarRegra() { return this.createEditRegra }
  set criarEditarRegra(value: boolean) { this.createEditRegra = value }
  get confirmarExclusao() { return this.confirmExclusao }
  set confirmarExclusao(value: boolean) { this.confirmExclusao = value }
  get search() { return this.getSuporteHospitaisStore.search }
  set search(value: string) { this.getSuporteHospitaisStore.setSearch(value) }

  get getSuporteHospitaisStore() {
    return getModule(SuporteHospitaisStore, this.$store)
  }

  get showModalDeFinxParaHis() { return this.getSuporteHospitaisStore.modal.deFinxParaHis }
  set showModalDeFinxParaHis(value: boolean) { this.getSuporteHospitaisStore.setModal({ name: 'deFinxParaHis', value }) }

  $refs!: {
    formDeFinxParaHis: HTMLFormElement
  }

  formDeFinxParaHisRules: any = {
    valid: true,
    propriedadeFinx: [],
    valorFinx: [],
    propriedadeHis: [],
    valorHis: [],
  }

  adicionarRegra() {
    this.getSuporteHospitaisStore.clearDeFinxParaHis()
    this.getSuporteHospitaisStore.setMode({ mode: 'CREATE' })
    this.criarEditarRegra = true
  }

  apagarRegraHis(item: DeFinxParaHis) {
    this.getSuporteHospitaisStore.setDeFinxParaHis(item)
    this.confirmarExclusao = true
  }

  editarRegraHis(item: DeFinxParaHis) {
    this.getSuporteHospitaisStore.setDeFinxParaHis(item)
    this.getSuporteHospitaisStore.setMode({ mode: 'EDIT' })
    this.criarEditarRegra = true
  }

  async upsertDeFinxParaHis() {
    this.loadingUpsertDeFinxParaHis = true
    if (this.$refs.formDeFinxParaHis.validate()) {
      const { mode } = this.getSuporteHospitaisStore
      const response = await this.getSuporteHospitaisStore.upsertDeFinxParaHis()
      if (response.success) {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: `Regra ${mode === 'CREATE' ? 'criada' : 'alterada'} com sucesso! ${String.fromCodePoint(0x1F642)}`,
          icon: 'done',
          color: '#2E7D32',
        })
      } else {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: response.message ? `${response.message} ${String.fromCodePoint(0x1F615)}` : `Ocorreu um erro ao ${mode === 'CREATE' ? 'criar' : 'alterar'} a regra ${String.fromCodePoint(0x1F615)}`,
          icon: 'warning',
          color: '#C62828',
        })
      }
      this.criarEditarRegra = false
    }
    this.loadingUpsertDeFinxParaHis = false
  }

  async deleteDeFinxParaHis() {
    this.loadingDeleteDeFinxParaHis = true
    const response = await this.getSuporteHospitaisStore.deleteDeFinxParaHis()
    if (response.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `Regra apagada com sucesso! ${String.fromCodePoint(0x1F642)}`,
        icon: 'done',
        color: '#2E7D32',
      })
    } else {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: response.message ? `${response.message} ${String.fromCodePoint(0x1F615)}` : `Ocorreu um erro ao apagar a regra ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
    }
    this.confirmarExclusao = false
    this.loadingDeleteDeFinxParaHis = false
  }

  @Watch('showModalDeFinxParaHis')
  onChangeShowModalDeFinxParaHis(value: boolean) {
    if (!value) {
      this.getSuporteHospitaisStore.clearConfigDeFinxParaHis()
      this.getSuporteHospitaisStore.setMode({ mode: 'CREATE' })
      this.getSuporteHospitaisStore.clearSearch()
      this.getSuporteHospitaisStore.clearHospitalId()
    }
  }

  @Watch('criarEditarRegra')
  onChangeCriarEditarRegra(value: boolean) {
    if (!value) {
      this.getSuporteHospitaisStore.clearDeFinxParaHis()
      this.$refs.formDeFinxParaHis.resetValidation()
    }
  }

  @Watch('confirmarExclusao')
  onChangeConfirmarExclusao(value: boolean) {
    if (!value) {
      this.getSuporteHospitaisStore.clearDeFinxParaHis()
    }
  }
}
